import { Link } from "react-router-dom";

const eventImage = "/assets/hardcastle/neighborhood-chat.jpg";

const events = [
  {
    title: "Neighborhood Chat - Evia/Campeche",
    date: "Thursday, April 30, 2026",
    location: "Empouria",
  },
  {
    title: "Neighborhood Chat - Dominique",
    date: "Monday, April 27, 2026",
    location: "2908 Dominique Dr",
  },
  {
    title: "Neighborhood Chat - West End",
    date: "Thursday, April 23, 2026",
    location: "Beachsiders Bar",
  },
  {
    title: "Neighborhood Chat - Beluche/Gerol",
    date: "Thursday, April 16, 2026",
    location: "2714 Beluche Dr",
  },
  {
    title: "Neighborhood Chat - LeBrun/Lakeview",
    date: "Monday, April 13, 2026",
    location: "27 Lebrun Ct",
  },
  {
    title: "Meet-and-Greet with Jason Hardcastle",
    date: "Thursday, April 9, 2026",
    location: "Empouria",
  },
];

function EventsPage() {
  return (
    <main className="bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">Events</p>
          <h1 className="mt-3 text-5xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
            Join us for a Neighborhood Chat.
          </h1>
          <p className="mt-5 text-lg leading-8 text-[#37516a]">
            Jason will be out and about all around District 6 meeting neighbors and having conversations about our collective vision for Galveston. Join one, or all, to ask questions and show your support.
          </p>
        </div>

        <section className="mt-12 grid gap-10 rounded-[2rem] bg-[#f7f1e6] p-8 shadow-xl lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
          <div>
            <img src={eventImage} alt="Ballot being placed in a box" className="w-full rounded-3xl bg-white object-cover shadow-lg" />
            <div className="mt-6 rounded-3xl bg-[#08213d] p-6 text-white shadow-lg">
              <p className="font-bold uppercase tracking-[0.2em] text-[#f7d77a]">Bring a friend</p>
              <p className="mt-3 leading-7 text-white/80">
                These are the campaign events currently listed on Jason&apos;s existing site. If a location changes, contact the campaign before heading over.
              </p>
            </div>
          </div>

          <div>
            <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">Latest first</p>
            <h2 className="mt-3 text-4xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
              Upcoming and recent campaign events.
            </h2>
            <div className="mt-8 grid gap-4">
              {events.map((event) => (
                <article key={`${event.date}-${event.title}`} className="rounded-3xl bg-white p-6 shadow-md ring-1 ring-black/5">
                  <p className="text-sm font-extrabold uppercase tracking-[0.16em] text-[#c0352b]">{event.date}</p>
                  <h3 className="mt-2 text-2xl font-black text-[#08213d]">{event.title}</h3>
                  <p className="mt-3 text-lg font-semibold text-[#37516a]">{event.location}</p>
                </article>
              ))}
            </div>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <Link to="/contact" className="rounded-full bg-[#0b2f58] px-7 py-3 text-center text-sm font-extrabold uppercase tracking-[0.16em] text-white transition hover:bg-[#143f70]">
                Contact us
              </Link>
              <Link to="/donate" className="rounded-full border-2 border-[#0b2f58] px-7 py-3 text-center text-sm font-extrabold uppercase tracking-[0.16em] text-[#0b2f58] transition hover:bg-white">
                Donate
              </Link>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default EventsPage;